import React from 'react';
import { ZfDivider, ZfStack, ZfTypography } from '@zafire/react';

export type ProductDetailRow = {
  label: string;
  value: string | number;
  testId?: string;
};

type Props = { rows: ProductDetailRow[] };

export const ProductDetailRows: React.FC<Props> = ({ rows }) => (
  <ZfStack direction="column" spacing="extra-extra-small">
    {rows.map((row, index) => (
      <React.Fragment key={`${row.label}-${index}`}>
        <ZfStack direction="row" justify="space-between" style={{ padding: '4px 0' }}>
          <ZfTypography variant="label-medium" color="muted">
            {row.label}
          </ZfTypography>
          <ZfTypography variant="body-medium" data-testid={row.testId}>
            {row.value}
          </ZfTypography>
        </ZfStack>
        <ZfDivider />
      </React.Fragment>
    ))}
  </ZfStack>
);
